import { initializeChakraComponent } from 'Shared/chakra-initialize';
import PopupContainer from './popup_container';

initializeChakraComponent('PopupModal', PopupContainer);
